module.exports = __webpack_public_path__ + "img/tc4.8712834d.png";